routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.payZoneDashboard', {
      url: "/zona-de-pagos/dashboard",
      template: `<pay-zone-dashboard sh-ctrl="shCtrl"></pay-zone-dashboard>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/dashboard/dashboard.config.js
 **/